import { PspContext } from "@/config/contexts";
import { setAccessTokenStorage, setRefreshTokenStorage } from "@/config/utils";
import { Dispatch, SetStateAction, useContext } from "react";
import { useNavigate } from "react-router-dom";

type UseLeftBarMobileParams = {
  setIsOpen: Dispatch<SetStateAction<boolean>>;
};

export function useLeftBarMobile({ setIsOpen }: UseLeftBarMobileParams) {
  const {
    lang,
    user,
    setLeftBarMobileOpen,
    selectedMandate,
    selectedMandateId,
  } = useContext(PspContext);
  const navigate = useNavigate();

  function onNavigate(path: string) {
    navigate(path);
    setIsOpen(false);
  }

  function onLogout() {
    // Get rid of all localstorage entries
    setAccessTokenStorage(null);
    setRefreshTokenStorage(null);

    // Close left bar
    setLeftBarMobileOpen(false);

    onNavigate("/login");
  }

  function closeLeftBarMobile() {
    setLeftBarMobileOpen(false);
  }

  const currentRight = user?.mandateRights.find(
    (mandateRight) => mandateRight.mandate.id === selectedMandateId,
  );

  return {
    lang,
    user,
    onLogout,
    closeLeftBarMobile,
    selectedMandate,
    currentRight,
  };
}
